<template>
    <v-icon v-if="value === 'S'" color="orange" :small="isSmall">wb_sunny</v-icon>
    <v-icon v-else-if="value === 'W'" color="grey" :small="isSmall">ac_unit</v-icon>
    <v-icon v-else-if="value === 'WS'" color="grey" :small="isSmall">ac_unit</v-icon>
    <v-icon v-else-if="value === 'A'" color="blue" :small="isSmall">rotate_right</v-icon>
</template>

<script>
    export default {
        props: ['value', 'small'],

        computed: {
            isSmall() {
                return this.small !== undefined;
            }
        }
    }
</script>